import { render, staticRenderFns } from "./TabsInfo.vue?vue&type=template&id=2caf9652&scoped=true"
import script from "./TabsInfo.vue?vue&type=script&lang=js"
export * from "./TabsInfo.vue?vue&type=script&lang=js"
import style0 from "./TabsInfo.vue?vue&type=style&index=0&id=2caf9652&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2caf9652",
  null
  
)

export default component.exports